import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppBar, CircularProgress, IconButton, Toolbar, Typography } from '@material-ui/core'
import { changeLoading } from '../../../../store/actions/loading.action'
import { chartGeneralPeriod, chartGeneralHourly, change } from '../../../../store/actions/campaigns.action'
import ChartPeriod from '../../../components/chart/chart-days'
import ChartHours from '../../../components/chart/chart-hours'
import { changeScreen } from '../../../../store/actions/navigation.action'
import { MdKeyboardBackspace } from 'react-icons/md'


export default function ChartCampaigns() {
    const dispatch = useDispatch()
    const { period, hour } = useSelector(state => state.campaignsReducer.chart)

    const [isLoading, setLoading] = React.useState(true)


    const [queryPeriod, setQueryPeriod] = React.useState({
        period: '7d',
        start_date: '',
        end_date: ''
    })

    const [queryHourly, setQueryHourly] = React.useState({
        period_hour: '24h',
        start_date: '',
        end_date: ''
    })

    React.useEffect(() => {
        return () => {
            dispatch(change('clear'))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        !isLoading && dispatch(changeLoading({ open: true }));
        
        _period()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryPeriod])

    React.useEffect(() => {
        !isLoading && dispatch(changeLoading({ open: true }));
        
        _hourly()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryHourly])

    const _period = (loading = false) => {
        dispatch(chartGeneralPeriod(queryPeriod, loading)).then(res => {
            setLoading(false)
            dispatch(changeLoading({ open: false }))
        })
    }

    const _hourly = (loading = false) => {
        dispatch(chartGeneralHourly(queryHourly, loading)).then(res => {
            setLoading(false)
            dispatch(changeLoading({ open: false }))
        })
    }

    const handleFilterPeriod = (filter) => {
        setQueryPeriod(prev => {
            const hasChanged = Object.keys(filter).some(
                key => prev[key] !== filter[key]
            );

            if (!hasChanged) return prev;

            return {
                ...prev,
                ...filter
            };
        });
    }

    const handleFilterHourly = (filter) => {
        setQueryHourly(prev => {
            const hasChanged = Object.keys(filter).some(
                key => prev[key] !== filter[key]
            );

            if (!hasChanged) return prev;

            return {
                ...prev,
                ...filter
            };
        });
    }

    return (
        <>
        <div className="app-bar">
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        Análise - Campanhas
                    </Typography>
                </Toolbar>
            </AppBar>

            {(isLoading) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                <>
                    <div className="card card-body bs-bg mt-3 mb-3">
                        <ChartPeriod
                            items={period.campaigns?.data || []}
                            chartData={period.period_chart || []}
                            today={period.today}
                            keyPrefix="campaign_"
                            titleField="title"
                            title={period?.period_label}
                            onChange={handleFilterPeriod}
                        />
                    </div>

                    <div className="card card-body bs-bg mb-3">
                        <ChartHours
                            items={hour?.campaigns?.data || []}
                            chartData={hour?.hourly_chart || []}
                            bestHour={hour?.best_hour}
                            bestWindow={hour?.best_window}
                            keyPrefix="campaign_"
                            titleField="title"
                            title={hour?.period_hour_label}
                            periodKey="period_hour"
                            defaultPeriod="24h"
                            presets={['24h', '7d', '1m', '3m', 'all']}
                            onChange={handleFilterHourly}
                        />
                    </div>
                </>
            }
            </div>
        </>
    )
}